const paths: Array<[string, string]> = [
	['/log-in', 'LoginRoute'],
	['/login-third-party', 'LogInThirdParty'],
	['/authorize', 'AuthorizeRoute'],
	['/forgot-password', 'LoginRoute'],
	['/forgot-password/check-email', 'CheckEmail'],
	['/reset-password', 'ResetPassword'],
	['/reset-password/success', 'ResetPasswordSuccess'],
];

export default paths;
